//#region src/bite_log_par_pay_event.ts
let BiteLogParPayEvent = /* @__PURE__ */ function(BiteLogParPayEvent) {
	BiteLogParPayEvent[BiteLogParPayEvent["None"] = 0] = "None";
	BiteLogParPayEvent[BiteLogParPayEvent["TerminalConnected"] = 1] = "TerminalConnected";
	BiteLogParPayEvent[BiteLogParPayEvent["TerminalDisconnected"] = 2] = "TerminalDisconnected";
	BiteLogParPayEvent[BiteLogParPayEvent["SaleTransaction"] = 3] = "SaleTransaction";
	BiteLogParPayEvent[BiteLogParPayEvent["SaleTransactionError"] = 4] = "SaleTransactionError";
	BiteLogParPayEvent[BiteLogParPayEvent["DeviceSetup"] = 5] = "DeviceSetup";
	BiteLogParPayEvent[BiteLogParPayEvent["CloseTransaction"] = 6] = "CloseTransaction";
	BiteLogParPayEvent[BiteLogParPayEvent["CloseTransactionError"] = 7] = "CloseTransactionError";
	BiteLogParPayEvent[BiteLogParPayEvent["NativeTransaction"] = 8] = "NativeTransaction";
	BiteLogParPayEvent[BiteLogParPayEvent["NativeRefundTransaction"] = 9] = "NativeRefundTransaction";
	BiteLogParPayEvent[BiteLogParPayEvent["RefundTransactionRequested"] = 10] = "RefundTransactionRequested";
	BiteLogParPayEvent[BiteLogParPayEvent["RefundTransaction"] = 11] = "RefundTransaction";
	BiteLogParPayEvent[BiteLogParPayEvent["RefundTransactionError"] = 12] = "RefundTransactionError";
	BiteLogParPayEvent[BiteLogParPayEvent["Logs"] = 13] = "Logs";
	BiteLogParPayEvent[BiteLogParPayEvent["CardBinRequest"] = 14] = "CardBinRequest";
	BiteLogParPayEvent[BiteLogParPayEvent["CardBinRequestError"] = 15] = "CardBinRequestError";
	BiteLogParPayEvent[BiteLogParPayEvent["TerminalRebootRequested"] = 16] = "TerminalRebootRequested";
	BiteLogParPayEvent[BiteLogParPayEvent["TerminalRebootSkipped"] = 17] = "TerminalRebootSkipped";
	return BiteLogParPayEvent;
}({});
//#endregion
export { BiteLogParPayEvent };

//# sourceMappingURL=bite_log_par_pay_event.js.map